/* tslint:disable */
/* eslint-disable */

/**
 * 1 = EnAttente
 * 2 = EnDemande
 * 3 = EnCours
 * 4 = Livre
 * 5 = Cloture
 * 6 = Annule
 */
export enum DemandeManutentionStatutValues {
  EnAttente = 1,
  EnDemande = 2,
  EnCours = 3,
  Livre = 4,
  Cloture = 5,
  Annule = 6
}
